import _0 from '../../../packages/@sanity/base/src/change-indicators/__workshop__'
import _1 from '../../../packages/@sanity/base/src/components/__workshop__'
import _2 from '../../../packages/@sanity/base/src/components/formField/__workshop__'
import _3 from '../../../packages/@sanity/base/src/components/previews/__workshop__'
import _4 from '../../../packages/@sanity/default-layout/src/navbar/__workshop__'
import _5 from '../../../packages/@sanity/default-layout/src/update/__workshop__'
import _6 from '../../../packages/@sanity/desk-tool/src/components/pane/__workshop__'
import _7 from '../../../packages/@sanity/desk-tool/src/panes/document/statusBar/__workshop__'
import _8 from '../../../packages/@sanity/field/src/diff/components/__workshop__'
import _9 from '../../../packages/@sanity/form-builder/src/__workshop__'
import _10 from '../../../packages/@sanity/form-builder/src/inputs/PortableText/__workshop__'

export const scopes = [
  _0,
  _1,
  _2,
  _3,
  _4,
  _5,
  _6,
  _7,
  _8,
  _9,
  _10,
]
